import styled from "@emotion/styled"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { ContentWrapper } from "../contentWrapper/ContentWrapper"

export const BackNavigationWrapper = styled(ContentWrapper)`
    padding-top: ${spacingStaticSm};
`
